import React from "react";
import { Card, Tabs } from "antd";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import BackButton from "../../../component/common/Back-Button";
import { useNavigate } from "react-router-dom";
import { role } from "../../../util/Route";
import MedicineTab from "./tab/MedicineTab";
import VaccinationTab from "./tab/VaccinationTab";
import DewormingTab from "./tab/DewormingTab";

const Medicine = () => {
    const menus = {
        medicine: <MedicineTab />,
        vaccination: <VaccinationTab />,
        deworming: <DewormingTab />,
    };
    const navigate = useNavigate()
    return (
        <>
            <div >

                <Card className="mt-5">
                    {(role === 'Admin' || role === 'ClientSupport') && <BackButton onClick={() => navigate(-1)} />}
                    <Tabs
                        className="p-0 m-0"
                        defaultActiveKey="1"
                        size="middle"
                        type="card"
                        items={CONSTANTS.TAB_MENU.MEDICINE.map((ele) => {
                            if (ele.Role?.includes(role)) {
                                return {
                                    label: `${ele.Label}`,
                                    key: `${ele.id}`,
                                    children: menus[ele?.id],
                                };
                            }
                        })}
                    />
                </Card>
            </div>
        </>
    );
};

export default Medicine;
